// Lightweight cross-component signal: the master-certificate "Add Policy" dialog and the
// dashboard's Policy List sidebar fetch independently (separate render trees, no shared
// state), so the sidebar has no way to know a policy was just created elsewhere. This lets
// the creator announce it without prop-drilling through AppLayout/RightPanel.
const target = new EventTarget();
const POLICY_CREATED = 'policy-created';

export function emitPolicyCreated(insuredId: string): void {
  target.dispatchEvent(new CustomEvent<{ insuredId: string }>(POLICY_CREATED, { detail: { insuredId } }));
}

export function onPolicyCreated(handler: (insuredId: string) => void): () => void {
  const listener = (e: Event) => handler((e as CustomEvent<{ insuredId: string }>).detail.insuredId);
  target.addEventListener(POLICY_CREATED, listener);
  return () => target.removeEventListener(POLICY_CREATED, listener);
}
